/**
 * dev：本地开发环境
 * test：测试环境
 * prod：生产环境
 */
type WebConfig = {
    apiUrl: string
    siteUrl: string
    loginUrl: string
    userUrl: string
}

const webConfigs: Record<'dev' | 'test' | 'prod', WebConfig> = {
    dev: {
        apiUrl: 'https://api.yunfei.plus',
        siteUrl: 'https://dev.yunfei.plus:3000',
        loginUrl: 'https://anqstar.yunfei.plus/user/login',
        userUrl: 'https://anqstar.yunfei.plus/user',
    },
    test: {
        apiUrl: 'https://api.yunfei.plus',
        siteUrl: 'https://campus.yunfei.plus',
        loginUrl: 'https://anqstar.yunfei.plus/user/login',
        userUrl: 'https://anqstar.yunfei.plus/user',
    },
    prod: {
        apiUrl: 'https://api.anqstar.com',
        siteUrl: 'https://tools.anqstar.com',
        loginUrl: 'https://www.anqstar.com/user/login',
        userUrl: 'https://www.anqstar.com/user',
    },
}

// 获取当前环境（Umi 4 框架使用 REACT_APP_ENV）
const env = (process.env.REACT_APP_ENV as keyof typeof webConfigs) || 'prod'

// 开发环境下打印当前环境配置
if (process.env.NODE_ENV === 'development') {
    console.log('🔧 当前环境:', env)
    console.log('🔧 REACT_APP_ENV:', process.env.REACT_APP_ENV)
    console.log('🔧 环境配置:', webConfigs[env])
}

// 导出当前环境配置
const webConfig = webConfigs[env]

export default webConfig
